<!-- TEMPLATE CONTRACT: Ui Profile Avatar Component owns the visible Angular template structure for src/app/shared/ui/ui-profile-avatar/ui-profile-avatar.component.html. -->
<div class="ui-profile-avatar">
  <div class="ui-profile-avatar__media">
    <!-- Conditional branch documents the visible UI state for this condition. -->
    @if (imageSrc()) {
      <img
        [src]="imageSrc()"
        [alt]="alt() | uiLabelTranslate"
        class="ui-profile-avatar__image"
        [class.ui-profile-avatar__image--loaded]="showLoadedImage()"
        (load)="onImageLoaded()"
        (error)="onImageError()"
      />
    }
    <!-- Conditional branch documents the visible UI state for this condition. -->
    @if (!showLoadedImage()) {
      <div class="ui-profile-avatar__fallback" aria-hidden="true">{{ displayInitials() }}</div>
    }

    <div class="ui-profile-avatar__overlay">
      <label class="ui-profile-avatar__action" [attr.aria-label]="editLabel() | uiLabelTranslate">
        <span class="material-symbols-rounded" aria-hidden="true">edit</span>
        <span>{{ editLabel() | uiLabelTranslate }}</span>
        <input class="ui-profile-avatar__input" type="file" accept="image/*" (change)="onFileSelected($event)" />
      </label>

      <!-- Conditional branch documents the visible UI state for this condition. -->
      @if (canDelete()) {
        <button type="button" class="ui-profile-avatar__action ui-profile-avatar__action--danger" (click)="onRemoveClicked()">
          <span class="material-symbols-rounded" aria-hidden="true">remove_circle</span>
          <span>{{ deleteLabel() | uiLabelTranslate }}</span>
        </button>
      }
    </div>
  </div>

  <!-- Conditional branch documents the visible UI state for this condition. -->
  @if (label() || hint()) {
    <div class="ui-profile-avatar__copy">
      <!-- Conditional branch documents the visible UI state for this condition. -->
      @if (label()) {
        <p class="ui-profile-avatar__label">{{ label() | uiLabelTranslate }}</p>
      }
      <!-- Conditional branch documents the visible UI state for this condition. -->
      @if (hint()) {
        <p class="ui-profile-avatar__hint">{{ hint() | uiLabelTranslate }}</p>
      }
    </div>
  }
</div>
